<template>
  <div v-if="isGetCookies === null" class="cookie-bar">
    <div class="cookie-bar-description">
      <p :style="{ 'margin': 0 + 'px' }">
        เว็บไซต์นี้มีการใช้คุกกี้ การใช้เว็บไซต์นี้ต่อไปถือว่าคุณยอมรับ<router-link :to="{ name: 'privacy-policy' }" target="_blank">นโยบายคุกกี้</router-link>และยินยอมให้มีการใช้งานคุกกี้
      </p>
    </div>
    <div>
      <b-button class="accept-cookie-button" @click="setCookie">รับทราบ</b-button>
      <!-- <b-button @click="setCookie">Deny Cookies</b-button> -->
    </div>
  </div>
</template>
<script>
export default {
  name: 'AppLayout',
  data () {
    return {
      cookies: this.$cookies.get('user_session')
    }
  },
  computed: { isGetCookies () {
    return this.cookies
  } },
  mounted () {
    // console.log('cookie', this.cookies)
  },
  methods: {
    setCookie () {
      this.cookies = this.$cookies.set('user_session', '1', -1)
    }
  }
}
</script>
<style lang='scss' scoped>
  .cookie-bar {
  z-index: 999999;
  position: fixed;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 60px;
  background: rgb(239, 239, 239);

  display: flex;
  justify-content: space-between;
  align-items: center;
  padding:25px
}
.cookie-bar-description{
  display:flex;
  align-items: center;
}
.accept-cookie-button {
  background-color: rgb(251, 131, 50);
  border-radius: 2px;
  border-style: none;
 &:hover {
       background-color: rgb(255, 174, 108);
    }
}
</style>
